import mitarbeiterbilder from "./mitarbeiterbilder"
import environment from "./environment"
import vueCustomElement from 'vue-custom-element'
import { isMobile, isAndroid, isMobileOnly, isSafari }  from 'mobile-device-detect';

export default {
  setUp: (vueInstance) => {
    vueInstance.use(mitarbeiterbilder);

    vueInstance.use(environment, { isMobile, isAndroid, isMobileOnly, isSafari });

    vueInstance.use(vueCustomElement)
  }
}
